export default __webpack_public_path__ + "static/media/change_icon3.f83c6a12.svg";